(function patchDrawImage() {
  const original = CanvasRenderingContext2D.prototype.drawImage;
  CanvasRenderingContext2D.prototype.drawImage = function(source, ...args) {
    const proxy = this.canvas._spinner360proxy;

    if (proxy !== undefined && args.length === 8) {
      if (proxy && source && source.src) {
        const newSrc = source.src.split('?')[0];
        if (proxy.src !== newSrc) proxy.src = newSrc;
      }
      const iw = source.naturalWidth || source.width;
      const ih = source.naturalHeight || source.height;
      const cw = this.canvas.width;
      const ch = this.canvas.height;
      const scale = Math.min(cw / iw, ch / ih);
      const dw = iw * scale;
      const dh = ih * scale;
      const dx = (cw - dw) / 2;
      const dy = (ch - dh) / 2;
      return original.call(this, source, 0, 0, iw, ih, dx, dy, dw, dh);
    }

    return original.apply(this, [source, ...args]);
  };
})();

function initSpinners() {
  if (!document.getElementById('spinner-touch-fix')) {
    const style = document.createElement('style');
    style.id = 'spinner-touch-fix';
    style.textContent = `
      slider-component.slider-mobile-gutter:has([data-spinner-360]) {
        touch-action: auto !important;
        pointer-events: auto !important;
      }
      slider-component.slider-mobile-gutter:has([data-spinner-360]) li,
      slider-component.slider-mobile-gutter:has([data-spinner-360]) ul {
        touch-action: auto !important;
        pointer-events: auto !important;
      }
      .spinner-360-bar {
        display: block !important;
      }
      .spinner-360-loader {
        display: none;
      }
      .spinner-hint-message {
        z-index: 2 !important;
      }
    `;
    document.head.appendChild(style);
  }

  document.querySelectorAll('[data-spinner-360]').forEach(function(el) {
    if (el.dataset.spinnerInit) return;
    el.dataset.spinnerInit = 'true';

    const canvas = el.querySelector('canvas');
    const proxy  = el.closest('.product__media')?.querySelector('.spinner-360-recorder-proxy');

    canvas.style.opacity = '0';
    canvas.style.transition = 'opacity 0.2s ease';

    if (proxy) proxy.removeAttribute('aria-hidden');

    canvas._spinner360proxy = proxy ?? null;

    const mediaContainer = el.closest('.product__media') || el.parentElement;
    const loader  = mediaContainer.querySelector('.spinner-360-loader');
    const bar     = mediaContainer.querySelector('.spinner-360-bar');
    const hintMsg = el.querySelector('.spinner-hint-message');

    function bridgeTouch(e) {
      e.stopPropagation();
      e.preventDefault();
      const touch = e.touches[0] || e.changedTouches[0];
      if (!touch) return;
      const typeMap = {
        touchstart: 'pointerdown',
        touchmove: 'pointermove',
        touchend: 'pointerup',
        touchcancel: 'pointercancel'
      };
      canvas.dispatchEvent(new PointerEvent(typeMap[e.type], {
        bubbles: true, cancelable: true,
        pointerId: touch.identifier + 1,
        pointerType: 'touch',
        clientX: touch.clientX,
        clientY: touch.clientY
      }));
    }
    canvas.addEventListener('touchstart', bridgeTouch, { passive: false });
    canvas.addEventListener('touchmove', bridgeTouch, { passive: false });
    canvas.addEventListener('touchend', bridgeTouch, { passive: false });
    canvas.addEventListener('touchcancel', bridgeTouch, { passive: false });

    function fixAncestorPointerEvents() {
      let ancestor = el.parentElement;
      while (ancestor) {
        ancestor.style.setProperty('pointer-events', 'auto', 'important');
        ancestor.style.setProperty('touch-action', 'auto', 'important');
        if (ancestor.tagName === 'SLIDER-COMPONENT') break;
        ancestor = ancestor.parentElement;
      }
    }

    fixAncestorPointerEvents();

    const pointerObserver = new MutationObserver(fixAncestorPointerEvents);
    let ancestor = el.parentElement;
    while (ancestor) {
      pointerObserver.observe(ancestor, { attributes: true, attributeFilter: ['style', 'class'] });
      if (ancestor.tagName === 'SLIDER-COMPONENT') break;
      ancestor = ancestor.parentElement;
    }

    const nP          = parseInt(el.dataset.nP);
    const nY          = parseInt(el.dataset.nY);
    const pZero       = Math.max(0, (parseInt(el.dataset.pZero) || 1) - 1);
    const yZero       = Math.max(0, (parseInt(el.dataset.yZero) || 1) - 1);
    const preload     = parseInt(el.dataset.preload);
    const sensitivity = parseFloat(el.dataset.sensitivity);
    const autoPlay    = el.dataset.autoplay === 'true';
    const atlasPath   = el.dataset.atlasPath;
    const fileRadix   = el.dataset.fileRadix;
    const fileExt     = el.dataset.fileExt;

    const hintAngle        = parseFloat(el.dataset.hintAngle) || 60;
    const hintDuration     = parseFloat(el.dataset.hintDuration) || 1000;
    const hintEase         = el.dataset.hintEase || 'ease-in-out';
    const hintEaseStrength = parseFloat(el.dataset.hintEaseStrength) || 5;
    const peakFps          = parseFloat(el.dataset.hintPeakFps) || 45;
    const hintDirection    = el.dataset.hintDirection === 'reverse' ? 'reverse' : 'forward';

    // Hide hint only on first real user drag
    el.addEventListener('pointerdown', (e) => {
      if (!e.isTrusted) return;
      if (hintMsg) hintMsg.style.opacity = '0';
    }, { once: true });

    const pad = (v) => String(v).padStart(4, '0');

    const images = [];
    for (let p = 1; p <= nP; p++) {
      const row = [];
      for (let y = nY; y >= 1; y--) {
        row.push(`${atlasPath}${fileRadix}_${pad(p)}_${pad(y)}${fileExt}`);
      }
      images.push(row);
    }

    function init(canvasClientWidth) {
      if (!window.WebexSpinner) {
        setTimeout(() => init(canvasClientWidth), 100);
        return;
      }

      canvas.width = 1080;
      canvas.height = 1080;

      if (loader) loader.style.display = 'flex';

      const allSrcs = images.flat();
      const preloadCount = Math.max(1, Math.ceil(allSrcs.length * (preload / 100)));
      let loadedCount = 0;
      let targetPct = 0;
      let displayPct = 0;

      const perfObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.name.includes('r2-spinner-proxy.joserdlg.workers.dev')) {
            loadedCount++;
            targetPct = Math.min(99, (loadedCount / preloadCount) * 100);
          }
        }
      });
      perfObserver.observe({ type: 'resource', buffered: true });

      let rafId;

      function animateBar() {
        const lerped = displayPct + (targetPct - displayPct) * 0.06;
        const crawlFloor = displayPct + Math.max(0.04, (targetPct - displayPct) * 0.01);
        displayPct = Math.min(Math.max(lerped, crawlFloor), 99);
        if (bar) bar.style.width = displayPct.toFixed(2) + '%';
        rafId = requestAnimationFrame(animateBar);
      }
      animateBar();

      const spinner = new window.WebexSpinner(canvas, {
        images,
        framesPerSecond: 30,
        preloadAmount: preload,
        draggable: true,
        dragSensitivity: sensitivity,
        touchBehavior: 'capture',
        autoPlay: autoPlay,
        pitchMinDegrees: -10,
        stepDegrees: 5,
        atlasColumns: 1,
        atlasRows: 1,
        invertHorizontalDrag: false,
        invertVerticalDrag: true,
        initialYawIndex: yZero
      });

      el._spinnerInstance = spinner;
      spinner.setDraggable(true);

      function runHintStep() {
        const steps = 20;
        const stepMs = hintDuration / steps;

        const speedCurve = (t) => {
          if (hintEase === 'linear') return peakFps;
          if (hintEase === 'ease-in') return Math.max(1, Math.pow(t, 2) * peakFps);
          if (hintEase === 'ease-out') return Math.max(1, (1 - Math.pow(1 - t, 2)) * peakFps);
          const exponent = Math.pow(2, (5 - hintEaseStrength) / 2);
          return Math.max(1, Math.pow(Math.sin(t * Math.PI), exponent) * peakFps);
        };

        const degPerFrame = 360 / nY;
        const targetFrames = Math.round(hintAngle / degPerFrame);
        let framesAdvanced = 0;
        let step = 0;

        function tick() {
          if (step >= steps || framesAdvanced >= targetFrames) {
            spinner.pause();
            spinner.setFrameRate(30);
            return;
          }
          spinner.setFrameRate(speedCurve(step / steps));
          if (step === 0) {
            spinner.setDirection(hintDirection);
            spinner.play();
          }
          framesAdvanced += (speedCurve(step / steps) * stepMs) / 1000;
          step++;
          setTimeout(tick, stepMs);
        }

        tick();
      }

      function revealSpinner() {
        spinner.play();
        requestAnimationFrame(() => {
          spinner.pause();
          spinner.setFrameRate(30);
          canvas.style.opacity = '1';
          if (proxy) proxy.style.zIndex = '2';
          if (loader) {
            loader.style.opacity = '0';
            loader.style.transition = 'opacity 0.3s ease';
            setTimeout(() => {
              loader.style.display = 'none';
              // Ensure hint is visible after loader hides
              // CSS z-index: 2 keeps it above canvas, opacity only hidden by real drag
              if (hintMsg) {
                hintMsg.style.opacity = '1';
                hintMsg.style.transition = 'opacity 0.3s ease';
              }
            }, 300);
          }
          setTimeout(runHintStep, 100);
        });
      }

      spinner.ready.then(() => {
        cancelAnimationFrame(rafId);
        perfObserver.disconnect();
        spinner.setPitch(pZero);
        spinner.setDraggable(true);

        if (bar) {
          bar.style.transition = 'width 0.2s linear';
          bar.style.width = '100%';
        }

        const rect = mediaContainer.getBoundingClientRect();
        const isVisible = rect.width > 0;

        if (isVisible) {
          revealSpinner();
        } else {
          if (loader) loader.style.display = 'none';
          el.dataset.spinnerReady = 'true';

          let revealed = false;

          function checkAndReveal() {
            if (revealed) return;
            if (el.dataset.spinnerReady !== 'true') return;
            const nowRect = mediaContainer.getBoundingClientRect();
            if (nowRect.width > 0) {
              revealed = true;
              el.dataset.spinnerReady = 'false';
              visibilityObserver.disconnect();
              revealSpinner();
            }
          }

          document.addEventListener('slideChanged', checkAndReveal);

          const slideEl = mediaContainer.closest('li') || mediaContainer.parentElement;
          const visibilityObserver = new MutationObserver(checkAndReveal);
          visibilityObserver.observe(slideEl, {
            attributes: true,
            attributeFilter: ['style', 'class', 'aria-hidden', 'hidden']
          });

          checkAndReveal();
        }

        canvas.addEventListener('pointerdown', () => {}, { capture: true });
        canvas.addEventListener('pointerup', () => {}, { capture: true });
      });
    }

    const canvasRect = canvas.getBoundingClientRect();
    const initWidth = canvasRect.width > 0
      ? canvasRect.width
      : mediaContainer.getBoundingClientRect().width || 600;
    init(initWidth);
  });
}

initSpinners();
document.addEventListener('DOMContentLoaded', initSpinners);
document.addEventListener('shopify:section:load', initSpinners);
document.addEventListener('slideChanged', initSpinners);
